import DarkFrameworkImages from '@vfgroup-oneplatform/framework/Themes/Modes/Dark/Images'

import images from '../../Images'

const Images = {
  ...DarkFrameworkImages,
  smsText: images.smsTextWhite,
  landline: images.landlineWhite,
  dataSharing: images.dataSharingWhite,
  offerDefaultIcon: images.offerDefaultIconWhite,
  idCard: images.idCardWhite,
  address: images.addressWhite,
  edit: images.edit,
  new_sim: images.new_sim_dark,
  bundle: images.bundle_dark,
  info: images.info_white
}

export default Images